import React, { useState, useMemo } from 'react'
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { Autocomplete } from '@material-ui/lab'
import Business from '@material-ui/icons/Business';
import { operators } from 'api/index'
import { useStoreState } from '../../../store/index'
import { useEffect } from 'react'
import { useTranslation } from 'hooks/useTranslation'

export default function ProfileCardV3({
	senderState,
	confirmationInfo,
	onChangeUserInfo,
	onChangeSenderType,
	onChangeCompanyInfo,
	onSubmitNormalPerson,
	onSubmitOrganizationInfo,
	onSubmitOrganizationBranch,
	addressList,
	branchList = [], // Add branchList prop with default empty array
}) {
	// eslint-disable-next-line
	const [selectPOAError, setSelectPOAError] = useState(false)
	// eslint-disable-next-line
	const [dbdData, setDbdData] = useState(null)
	const userSDOC = useStoreState(s => s.sdocUserModel.userSDOC)
	const { t, language } = useTranslation()
	const prefixMap = t('form.prefixMap')

	const [ProvinceList, setProvinceList] = useState([]);
	const [DistrictList, setDistrictList] = useState([]);
	const [AmphoeList, setAmphoeList] = useState([]);
	const [ProvinceListNP, setProvinceListNP] = useState([]);
	const [DistrictListNP, setDistrictListNP] = useState([]);
	const [AmphoeListNP, setAmphoeListNP] = useState([]);

	const [currentProvince, setCurrentProvince] = useState('');
	const [currentAmphoe, setCurrentAmphoe] = useState('');
	const [currentDistrict, setCurrentDistrict] = useState('');

	const provinceEngMap = useMemo(() => {
		if (!addressList?.length) return {}
		const map = {}
		addressList.forEach(a => { if (a.province && !map[a.province]) map[a.province] = a.provinceEng })
		return map
	}, [addressList])

	const amphoeEngMapOrg = useMemo(() => {
		if (!addressList?.length || !currentProvince) return {}
		const map = {}
		addressList.filter(a => a.province === currentProvince)
			.forEach(a => { if (a.amphoe && !map[a.amphoe]) map[a.amphoe] = a.amphoeEng })
		return map
	}, [addressList, currentProvince])

	const districtEngMapOrg = useMemo(() => {
		if (!addressList?.length || !currentProvince || !currentAmphoe) return {}
		const map = {}
		addressList.filter(a => a.province === currentProvince && a.amphoe === currentAmphoe)
			.forEach(a => { if (a.district && !map[a.district]) map[a.district] = a.districtEng })
		return map
	}, [addressList, currentProvince, currentAmphoe])

	const amphoeEngMapNP = useMemo(() => {
		const province = confirmationInfo.normal_person?.province
		if (!addressList?.length || !province) return {}
		const map = {}
		addressList.filter(a => a.province === province)
			.forEach(a => { if (a.amphoe && !map[a.amphoe]) map[a.amphoe] = a.amphoeEng })
		return map
	}, [addressList, confirmationInfo.normal_person?.province])

	const districtEngMapNP = useMemo(() => {
		const province = confirmationInfo.normal_person?.province
		const amphoe = confirmationInfo.normal_person?.amphoe
		if (!addressList?.length || !province || !amphoe) return {}
		const map = {}
		addressList.filter(a => a.province === province && a.amphoe === amphoe)
			.forEach(a => { if (a.district && !map[a.district]) map[a.district] = a.districtEng })
		return map
	}, [addressList, confirmationInfo.normal_person?.province, confirmationInfo.normal_person?.amphoe])

	const isEmailValid = (email) => {
		// Simple email validation check
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};


	const initProvinceList = async () => {
		const availableSelection = { province: [], district: [], amphoe: [] }
		addressList.map((item) => {
			if (!availableSelection.province.includes(item.province)) {
				availableSelection.province.push(item.province)
			}
		})
		setProvinceList(availableSelection.province)
		setProvinceListNP(availableSelection.province)
	}

	const updateAvailableAddress = async (name, value) => {
		var availableAddress = []
		if (name == 'province') {
			setCurrentProvince(value)
			availableAddress = addressList.filter((item) => item.province === value)
		} else if (name == 'amphoe') {
			setCurrentAmphoe(value)
			availableAddress = addressList.filter((item) =>
				item.province === currentProvince &&
				item.amphoe === value)
		} else if (name == 'district') {
			setCurrentDistrict(value)
			availableAddress = addressList.filter((item) =>
				item.province === currentProvince &&
				item.amphoe === currentAmphoe &&
				item.district === value)
		}

		if (availableAddress.length > 0) {
			const availableSelection = { province: [], district: [], amphoe: [], zipcode: [] }
			availableAddress.map((item) => {
				if (!availableSelection.district.includes(item.district)) {
					availableSelection.district.push(item.district)
				}
				if (!availableSelection.amphoe.includes(item.amphoe)) {
					availableSelection.amphoe.push(item.amphoe)
				}
				if (!availableSelection.zipcode.includes(item.zipcode)) {
					availableSelection.zipcode.push(item.zipcode)
				}
			})
			// setProvinceListNP(availableSelection.province)
			if (name == 'province') {
				setAmphoeList(availableSelection.amphoe)
				setDistrictList([]);
			} else if (name == 'amphoe') {
				setDistrictList(availableSelection.district)
			} else if (name == 'district') {
				let newData = confirmationInfo.organization
				onChangeCompanyInfo({
					...newData,
					district: value,
					zipcode: availableSelection.zipcode[0],
				})
			}
		} else {
			setDistrictList([]);
			setAmphoeList([]);
			let newData = confirmationInfo.organization
			onChangeUserInfo({
				...newData,
				district: '',
				amphoe: '',
				province: '',
				zipcode: '',
			})
		}
	}

	const updateAvailableAddressNP = async (name, value) => {
		var availableAddress = []
		if (name == 'province') {
			availableAddress = addressList.filter((item) => item.province === value)
		} else if (name == 'amphoe') {
			availableAddress = addressList.filter((item) =>
				item.province === confirmationInfo.normal_person.province &&
				item.amphoe === value)
		} else if (name == 'district') {
			availableAddress = addressList.filter((item) =>
				item.province === confirmationInfo.normal_person.province &&
				item.amphoe === confirmationInfo.normal_person.amphoe &&
				item.district === value)
		}

		if (availableAddress.length > 0) {
			const availableSelection = { province: [], district: [], amphoe: [], zipcode: [] }
			availableAddress.map((item) => {
				if (!availableSelection.district.includes(item.district)) {
					availableSelection.district.push(item.district)
				}
				if (!availableSelection.amphoe.includes(item.amphoe)) {
					availableSelection.amphoe.push(item.amphoe)
				}
				if (!availableSelection.zipcode.includes(item.zipcode)) {
					availableSelection.zipcode.push(item.zipcode)
				}
			})
			// setProvinceListNP(availableSelection.province)
			if (name == 'province') {
				setAmphoeListNP(availableSelection.amphoe)
				setDistrictListNP([]);
			} else if (name == 'amphoe') {
				setDistrictListNP(availableSelection.district)
			} else if (name == 'district') {
				let newData = confirmationInfo.normal_person
				onChangeUserInfo({
					...newData,
					district: value,
					zipcode: availableSelection.zipcode[0],
				})
			}
		} else {
			setDistrictListNP([]);
			setAmphoeListNP([]);
			let newData = confirmationInfo.normal_person
			onChangeUserInfo({
				...newData,
				district: '',
				amphoe: '',
				province: '',
				zipcode: '',
			})
		}
	}

	const handleBranchSelect = async (event, value, isNew = false) => {
		// console.log("handleBranchSelect", value, isNew);
		let branchNo = '';
		if (typeof value === 'string') {
			branchNo = value;
		} else if (value && value.branchNo) {
			branchNo = value.branchNo;
		}

		// Allow only numbers and max 5 digits
		const numericBranchNo = branchNo.replace(/[^0-9]/g, '').slice(0, 5);

		let newData = confirmationInfo.organization;
		onChangeCompanyInfo({ ...newData, branchNo: numericBranchNo });

		// Attempt to find if this branch exists in our list (even if typed manually)
		const selectedBranch = branchList.find(b => b.branchNo === numericBranchNo);


		if (selectedBranch) {
			// Found existing branch - Auto-fill
			onChangeCompanyInfo({
				...newData,
				branchNo: numericBranchNo,
				address: selectedBranch.address ?? selectedBranch.addr ?? '', // Handle different property names from API
				email: selectedBranch.email ?? '',
				mobile: selectedBranch.mobile ?? '',
				district: selectedBranch.district ?? '',
				amphoe: selectedBranch.amphoe ?? '',
				province: selectedBranch.province ?? '',
				zipcode: selectedBranch.zipcode ?? '',
			});
			setCurrentProvince(selectedBranch.province);
			setCurrentAmphoe(selectedBranch.amphoe);
			setCurrentDistrict(selectedBranch.district);
		} else if (isNew) {
			// New branch (only for companies) - Clear fields or keep as is?
			// Implementation plan said: If new value -> Clear address fields (or keep empty) for user to fill.
			// However, to be user friendly, we might only want to clear if we are explicitly switching "away" from a valid branch.
			// But since we are typing, it's safer to clear to avoid confusion, UNLESS the user has already started typing the address.
			// For simplicity and correctness: If it doesn't match a known branch, we assume it's new and let user fill it.
			// BUT, verify if we should clear fields. If user edits branch no, they probably expect address to change or be empty.
			// Let's clear address fields to prevent mixing data.
			onChangeCompanyInfo({
				...newData,
				branchNo: numericBranchNo,
				address: '',
				email: '',
				mobile: '',
				district: '',
				amphoe: '',
				province: '',
				zipcode: '',
			});
			setCurrentProvince('');
			setCurrentAmphoe('');
			setCurrentDistrict('');
		}
	}

	const isCompany = (taxId) => {
		return taxId && taxId.startsWith('0');
	}

	const getPrefixOptions = (taxId) => {
		if (isCompany(taxId)) {
			return ["บริษัท", "ห้างหุ้นส่วน", "ห้างหุ้นส่วนจำกัด", "อื่นๆ"];
		} else {
			return ["ร้าน", "ร้านค้า", "อื่นๆ"];
		}
	}

	const handleInput = async e => {
		const { name, value } = e.target
		const numericValue = name === 'mobile' || name === 'zipcode' || name === 'branchNo' ? value.replace(/[^0-9]/g, '') : value;
		let newData = confirmationInfo.organization
		onChangeCompanyInfo({ ...newData, [name]: numericValue })

		if (name === 'branchNo') {
			// This logic is now handled by handleBranchSelect / Autocomplete mostly,
			// but we still keep it if triggered directly (though we'll use Autocomplete)
			// OR if we keep the "search from API" logic for fallback.
			// Since we have branchList passed down, we rely on that.
			// However, the original code called `operators.getOperatorInfo` which is an API call.
			// If `branchList` is complete, we don't need the API call.
			// Assuming `branchList` from `profile` page contains ALL branches.
			// We can replicate the logic inside `handleBranchSelect`.
		} else if (name === 'province' || name === 'district' || name === 'amphoe') {
			updateAvailableAddress(name, value)
			if (name == 'province') {
				onChangeCompanyInfo({ ...newData, [name]: value, amphoe: '', district: '', zipcode: '' })
			} else if (name == 'amphoe') {
				onChangeCompanyInfo({ ...newData, [name]: value, district: '', zipcode: '' })
			}
		}
	}
	const handleUserInput = e => {
		const { name, value } = e.target
		// console.log('name', name, 'value', value)
		const numericValue = name === 'mobile' || name === 'zipcode' ? value.replace(/[^0-9]/g, '') : value;
		let newData = confirmationInfo.normal_person;
		onChangeUserInfo({ ...newData, [name]: numericValue });

		if (name === 'province' || name === 'district' || name === 'amphoe') {
			updateAvailableAddressNP(name, value)
			if (name == 'province') {
				onChangeUserInfo({ ...newData, [name]: value, amphoe: '', district: '', zipcode: '' })
			} else if (name == 'amphoe') {
				onChangeUserInfo({ ...newData, [name]: value, district: '', zipcode: '' })
			}
		}
	}



	useEffect(() => {
		if (addressList.length > 0) {
			// console.log(confirmationInfo)
			initProvinceList()
			updateAvailableAddressNP('province', confirmationInfo.normal_person.province)
			updateAvailableAddressNP('amphoe', confirmationInfo.normal_person.amphoe)
			// updateAvailableAddressNP('district', confirmationInfo.normal_person.district)
			if (userSDOC.poa && confirmationInfo.organization.branchNo.length === 5) {
				setCurrentProvince(confirmationInfo.organization.province)
				setCurrentAmphoe(confirmationInfo.organization.amphoe)
				// setCurrentDistrict(confirmationInfo.organization.district)
			}
		}
		// eslint-disable-next-line
	}, [addressList])

	useEffect(() => {
		if (addressList.length > 0) {
			updateAvailableAddress('province', currentProvince)
		}
	}, [currentProvince])
	useEffect(() => {
		if (addressList.length > 0) {
			updateAvailableAddress('amphoe', currentAmphoe)
		}
	}, [currentAmphoe])
	useEffect(() => {
		if (addressList.length > 0) {
			// updateAvailableAddress('district', currentDistrict)
		}
	}, [currentDistrict])

	return (
		<Card className={`border-t-4 border-card_top_border mb-5`}>
			<Grid className="flex flex-col justify-center items-start px-5 mb-5">
				{/* Header */}
				<Grid className="flex flex-row mt-4 mb-2">
					<Business style={{ fontSize: 22 }} className="mr-1" />
					<Grid className="font-bold text-sm text-card_header_color">
						{t('profileCard.header')}
					</Grid>
				</Grid>
				<Grid className="mt-3 mb-1 w-full">
					<Divider />
				</Grid>
				{/* Normal Person or Organization */}
				<Grid className="flex flex-row items-center justify-between w-full">
					<Grid className="flex flex-col gap-y-2 mt-4">
						<Grid>{t('profileCard.senderTypeLabel')}</Grid>
						<RadioGroup
							row
							name="type"
							value={senderState}
							onChange={onChangeSenderType}>
							<FormControlLabel
								value={'normal_person'}
								control={<Radio />}
								label={t('profileCard.normalPerson')}

							/>
							{(userSDOC.poa) && (
								<FormControlLabel
									value={'organization'}
									control={<Radio />}
									label={isCompany(userSDOC.poa) ? t('profileCard.organization') : t('profileCard.shop')}
								/>
							)}
						</RadioGroup>
					</Grid>
				</Grid>
				{/* Normal Person or Organization's Name */}
				{senderState === 'normal_person' && (
					<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
						<Grid className="flex flex-row">
							<Grid>{t('profileCard.nationalID')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<Grid
							className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
							<InputBase
								className="w-full"
								name="cardNo"
								readOnly
								disabled
								value={confirmationInfo.normal_person.cardNo}
							/>
						</Grid>
						{/* <Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>เลขที่สาขา</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
								<InputBase
									className="w-full"
									name="branchNo"
									value={confirmationInfo.normal_person.branchNo}
									onChange={handleUserInput}
								/>
							</Grid>
						</Grid> */}
						<Grid className="flex flex-row">
							<Grid>{t('profileCard.prefix')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<FormControl variant="outlined" fullWidth size="small">
							{/* <InputBase
								className="w-full"
								name="prefix"
								value={confirmationInfo.normal_person.prefix}
								onChange={handleUserInput}
							/> */}
							<Select
								className="w-full"
								name="prefix"
								value={confirmationInfo.normal_person.prefix}
								onChange={handleUserInput}
							>
								<MenuItem value="นาย">{prefixMap?.['นาย'] ?? 'นาย'}</MenuItem>
								<MenuItem value="นาง">{prefixMap?.['นาง'] ?? 'นาง'}</MenuItem>
								<MenuItem value="นางสาว">{prefixMap?.['นางสาว'] ?? 'นางสาว'}</MenuItem>
								<MenuItem value="ท่านผู้หญิง">{prefixMap?.['ท่านผู้หญิง'] ?? 'ท่านผู้หญิง'}</MenuItem>
								{/* <MenuItem value="คุณ">คุณ</MenuItem> */}
							</Select>
						</FormControl>
						{
							// if branchNo is 00000 or null then show this
							(confirmationInfo.normal_person.branchNo === '00000' || confirmationInfo.normal_person.branchNo === null) ? (
								<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.fullName')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<Grid
										className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
										<InputBase
											className="w-full"
											name="name"
											readOnly
											disabled
											value={confirmationInfo.normal_person.name}
										/>
									</Grid>
								</Grid>
							) : (
								<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.shopName')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<Grid
										className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
										<InputBase
											className="w-full"
											name="firstname"
											readOnly
											value={confirmationInfo.normal_person.firstName}
											onChange={handleUserInput}
										/>
									</Grid>
								</Grid>
							)}
						{/* <Grid className="flex flex-row">
							<Grid>{t('profileCard.address')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<Grid
							className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
							<InputBase
								className="w-full"
								name="address"
								value={confirmationInfo.normal_person.address}
								onChange={handleUserInput}
							/>
						</Grid> */}
						<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
							<Grid className="flex flex-row">
								<Grid>{t('profileCard.address')}</Grid>
								<Grid className="text-red-500">*</Grid>
							</Grid>
							{/* <Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="address"
										value={confirmationInfo.organization.address}
										onChange={handleInput}
									/>
								</Grid> */}
							<Grid
								className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full`}>
								<TextField
									fullWidth
									variant="outlined"
									size="small"
									className="w-full"
									name="addr"
									value={confirmationInfo.normal_person.addr}
									onChange={handleUserInput}
									placeholder={t('profileCard.addressPlaceholder')}
									label={t('profileCard.addressPlaceholder')}
								/>
							</Grid>
							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.province')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<FormControl variant="outlined" fullWidth size="small">
									<Select
										name="province"
										onChange={handleUserInput}
										value={confirmationInfo.normal_person.province}
										label={t('profileCard.province')}
										disabled={ProvinceListNP.length === 0}
										placeholder={t('profileCard.province')}>
										{/* <MenuItem value={""}>จังหวัด</MenuItem> */}
										{ProvinceListNP.map((item, index) => (
											<MenuItem key={index} value={item}>{language === 'en' ? (provinceEngMap[item] ?? item) : item}</MenuItem>
										))}

									</Select>
								</FormControl>
							</Grid>
							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.district')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<FormControl variant="outlined" fullWidth size="small">
									<Select
										name="amphoe"
										onChange={handleUserInput}
										value={confirmationInfo.normal_person.amphoe}
										disabled={AmphoeListNP.length === 0}
										placeholder={t('profileCard.district')}>
										{/* <MenuItem value={""}>เลือกอำเภอ</MenuItem> */}
										{AmphoeListNP.map((item, index) => (
											<MenuItem key={index} value={item}>{language === 'en' ? (amphoeEngMapNP[item] ?? item) : item}</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.subdistrict')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<FormControl variant="outlined" fullWidth size="small">
									<Select
										name="district"
										onChange={handleUserInput}
										value={confirmationInfo.normal_person.district}
										label="district"
										disabled={DistrictListNP.length === 0}
										placeholder={t('profileCard.subdistrict')}>
										{/* <MenuItem value={""}>เลือกตำบล</MenuItem> */}
										{DistrictListNP.map((item, index) => (
											<MenuItem key={index} value={item}>{language === 'en' ? (districtEngMapNP[item] ?? item) : item}</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.zipcode')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<InputBase
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}
									name="zipcode"
									onChange={handleUserInput}
									inputProps={{ maxLength: 5 }}
									// readOnly
									value={confirmationInfo.normal_person.zipcode}
									placeholder={t('profileCard.zipcode')}
								/>
							</Grid>






						</Grid>

						<Grid className="flex flex-row">
							<Grid>Email</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<Grid
							className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
							<InputBase
								className="w-full"
								name="email"

								onChange={handleUserInput}
								value={confirmationInfo.normal_person.email}
							/>
						</Grid>


						<Grid className="flex flex-row">
							<Grid>{t('profileCard.phone')}</Grid>
							<Grid className="text-red-500">*</Grid>
						</Grid>
						<Grid
							className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
							<InputBase
								className="w-full"
								name="mobile"
								inputProps={{ maxLength: 10 }}
								type="tel"
								onChange={handleUserInput}
								value={confirmationInfo.normal_person.mobile}
							/>
						</Grid>
						<Grid className="flex flex-row justify-end items-end w-full gap-x-2 my-10">
							<Button
								className={`w-2/12`}
								color="primary"
								variant="contained"
								onClick={onSubmitNormalPerson}
								disabled={confirmationInfo.normal_person.prefix === '' || confirmationInfo.normal_person.addr.length < 2 || confirmationInfo.normal_person.district === '' || confirmationInfo.normal_person.amphoe === '' || confirmationInfo.normal_person.province === '' || confirmationInfo.normal_person.email === '' || confirmationInfo.normal_person.mobile === '' || confirmationInfo.normal_person.zipcode.length < 5 || !isEmailValid(confirmationInfo.normal_person.email)}
							>
								{t('profileCard.savePersonal')}
							</Button>
						</Grid>
					</Grid>
				)}

				{senderState === 'organization' && (
					<>
						<Grid className="flex flex-row w-full">
							<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
								<Grid style={{ fontSize: 20 }}>{isCompany(confirmationInfo.organization.cardNo) ? t('profileCard.companyData') : t('profileCard.shopData')}</Grid>
								<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.taxID')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<Grid
										className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
										<InputBase
											className="w-full"
											name="cardNo"
											readOnly
											disabled
											value={confirmationInfo.organization.cardNo = userSDOC.poa}
										// value={userSDOC.poa}
										/>
									</Grid>
								</Grid>

								<Grid style={{ display: 'none' }}>
									<Grid className="flex flex-row">
										<Grid>ประเภทสถานประกอบการ</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<Grid
										className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
										<InputBase
											className="w-full"
											name="typeName"
											value={confirmationInfo.organization.typeName}
										// onChange={handleInput}
										/>
									</Grid>
								</Grid>

								<Grid className="flex flex-row">
									<Grid>{isCompany(confirmationInfo.organization.cardNo) ? t('profileCard.companyPrefix') : t('profileCard.shopType')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<FormControl variant="outlined" fullWidth size="small">
									<Select
										className="w-full"
										name="prefix"
										onChange={handleInput}
										value={confirmationInfo.organization.prefix}
									>
										{getPrefixOptions(confirmationInfo.organization.cardNo).map((option) => (
											<MenuItem key={option} value={option}>{prefixMap?.[option] ?? option}</MenuItem>
										))}

									</Select>
									{confirmationInfo.organization.prefix === "อื่นๆ" && (
										<Grid
											className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>

											<InputBase
												className="w-full"
												name="prefixother"
												value={confirmationInfo.organization.prefixother}
												placeholder={t('profileCard.specify')}
												onChange={handleInput}
											/>
										</Grid>
									)}

								</FormControl>

								<Grid className="flex flex-row">
									<Grid>{isCompany(confirmationInfo.organization.cardNo) ? t('profileCard.companyName') : t('profileCard.shopName')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="name"
										onChange={handleInput}
										value={confirmationInfo.organization.name}
									/>
								</Grid>
								<Grid className="flex flex-row justify-end items-end w-full gap-x-2 my-10">
									<Button
										className={`w-2/12`}
										color="primary"
										variant="contained"
										onClick={onSubmitOrganizationInfo}
										disabled={confirmationInfo.organization.prefix === "" || confirmationInfo.organization.name.length < 2}
									>
										{isCompany(confirmationInfo.organization.cardNo) ? t('profileCard.saveCompany') : t('profileCard.saveShop')}
									</Button>
								</Grid>
							</Grid>
						</Grid>
						<Grid className="mb-1 w-full">
							<Divider />
						</Grid>
						<Grid style={{ fontSize: 20 }}>{t('profileCard.branchData')}</Grid>
						<Grid className={`flex flex-col w-full`}>

							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.branchNo')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-full w-full `}>
									{isCompany(confirmationInfo.organization.cardNo) ? (
										<Autocomplete
											freeSolo
											className="w-full"
											options={branchList}
											getOptionLabel={(option) => {
												if (typeof option === 'string') return option;
												return option.branchNo;
											}}
											value={confirmationInfo.organization.branchNo}
											onChange={(event, newValue) => handleBranchSelect(event, newValue, true)}
											onInputChange={(event, newInputValue) => {
												if (event && event.type === 'change') {
													handleBranchSelect(event, newInputValue, true);
												}
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													variant="outlined"
													size="small"
													placeholder={t('profileCard.branchNoPlaceholder')}
												/>
											)}
										/>
									) : (
										<FormControl variant="outlined" className="w-full" size="small">
											<Select
												name="branchNo"
												value={confirmationInfo.organization.branchNo}
												onChange={(e) => handleBranchSelect(e, e.target.value)}
												displayEmpty
											>
												<MenuItem value="" disabled>{t('profileCard.selectBranch')}</MenuItem>
												{branchList.map((branch) => (
													<MenuItem key={branch.branchNo} value={branch.branchNo}>
														{branch.branchNo}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									)}
								</Grid>
							</Grid>

							<Grid className={`flex flex-col items-start my-2 w-full gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.address')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								{/* <Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="address"
										value={confirmationInfo.organization.address}
										onChange={handleInput}
									/>
								</Grid> */}
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full`}>
									<TextField
										fullWidth
										variant="outlined"
										size="small"
										className="w-full"
										name="address"
										value={confirmationInfo.organization.address}
										onChange={handleInput}
										placeholder={t('profileCard.addressPlaceholder')}
										label={t('profileCard.addressPlaceholder')}
									/>
								</Grid>
								<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.province')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<FormControl variant="outlined" fullWidth size="small">
										<Select
											name="province"
											onChange={handleInput}
											value={confirmationInfo.organization.province}
											label={t('profileCard.province')}
											disabled={ProvinceList.length === 0}
											placeholder={t('profileCard.province')}>
											{/* <MenuItem value={""}>จังหวัด</MenuItem> */}
											{ProvinceList.map((item, index) => (
												<MenuItem key={index} value={item}>{language === 'en' ? (provinceEngMap[item] ?? item) : item}</MenuItem>
											))}

										</Select>
									</FormControl>
								</Grid>
								<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.district')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<FormControl variant="outlined" fullWidth size="small">
										<Select
											name="amphoe"
											onChange={handleInput}
											value={confirmationInfo.organization.amphoe}
											disabled={AmphoeList.length === 0}
											placeholder={t('profileCard.district')}>
											{/* <MenuItem value={""}>เลือกอำเภอ</MenuItem> */}
											{AmphoeList.map((item, index) => (
												<MenuItem key={index} value={item}>{language === 'en' ? (amphoeEngMapOrg[item] ?? item) : item}</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.subdistrict')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<FormControl variant="outlined" fullWidth size="small">
										<Select
											name="district"
											onChange={handleInput}
											value={confirmationInfo.organization.district}
											label="district"
											disabled={DistrictList.length === 0}
											placeholder={t('profileCard.subdistrict')}>
											{/* <MenuItem value={""}>เลือกตำบล</MenuItem> */}
											{DistrictList.map((item, index) => (
												<MenuItem key={index} value={item}>{language === 'en' ? (districtEngMapOrg[item] ?? item) : item}</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
									<Grid className="flex flex-row">
										<Grid>{t('profileCard.zipcode')}</Grid>
										<Grid className="text-red-500">*</Grid>
									</Grid>
									<InputBase
										className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}
										name="zipcode"
										onChange={handleInput}
										inputProps={{ maxLength: 5 }}
										// readOnly
										value={confirmationInfo.organization.zipcode}
										placeholder={t('profileCard.zipcode')}
									/>
								</Grid>

							</Grid>

							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>Email</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="email"
										onChange={handleInput}
										value={confirmationInfo.organization.email}
									/>
								</Grid>
							</Grid>

							<Grid className={`flex flex-col items-start my-2 w-1/3 gap-y-3`}>
								<Grid className="flex flex-row">
									<Grid>{t('profileCard.phone')}</Grid>
									<Grid className="text-red-500">*</Grid>
								</Grid>
								<Grid
									className={`px-2 text-xs flex justify-start items-center rounded h-10 w-full border border-gray-300`}>
									<InputBase
										className="w-full"
										name="mobile"
										onChange={handleInput}
										inputProps={{ maxLength: 10 }}
										value={confirmationInfo.organization.mobile}
									/>
								</Grid>
							</Grid>

							<Grid className="flex flex-row justify-end items-end w-full gap-x-2 my-10">
								<Button
									className={`w-2/12`}
									color="primary"
									variant="contained"
									onClick={onSubmitOrganizationBranch}
									disabled={confirmationInfo.organization.address.length < 1 || confirmationInfo.organization.district.length < 1 || confirmationInfo.organization.amphoe.length < 1 || confirmationInfo.organization.province.length < 1 || confirmationInfo.organization.email.length < 1 || confirmationInfo.organization.mobile.length < 1 || confirmationInfo.organization.zipcode.length < 5 || !isEmailValid(confirmationInfo.organization.email)}
								>
									{t('profileCard.saveBranch')}
								</Button>
							</Grid>


						</Grid>
					</>
				)}


			</Grid>
		</Card>
	)
}
